import moment from 'moment';
import { DateAcceptedFormatType } from '../../types';

const getDateFormat = () => localStorage.getItem('DateFormat');
const saveDateFormat = (format: DateAcceptedFormatType) =>
  localStorage.setItem('DateFormat', format);

export function getSystemDefaultDateFormat(): DateAcceptedFormatType {
  // Use moment.js to get the user's locale
  const locale = moment.locale();

  let format = getDateFormat();

  if (format) return format as DateAcceptedFormatType;

  // const appFormat = localStorage.getItem(dateFormatLSId)
  // if (appFormat) return appFormat as DateAcceptedFormatTypes;

  // Use the locale to determine the user's date format
  const date = moment('2022-01-01').locale(locale);
  const monthFirst = date.format('L') === '01/01/2022';
  const dateFormat = monthFirst
    ? DateAcceptedFormatType.MonthFirst
    : DateAcceptedFormatType.DayFirst;
  saveDateFormat(dateFormat);

  return dateFormat;
}

const generateMonthFirstFormats = (separator: string) => [
  `MM${separator}DD`, // 12-06

  `MM${separator}D`, // 05-1
  `M${separator}D`, // 5-1

  `MMMM${separator}D`, // May-1
  `MMM${separator}D`, // May-1
  `MMM${separator}DD`, // May-01

  `MM${separator}DD${separator}YY`, // 06-12-23
  `MM${separator}DD${separator}YYYY`, // 12-06-2023
  `MM${separator}D${separator}YYYY`, // 05-1-2023
  `M${separator}D${separator}YY`, // 5-1-2023
  `M${separator}D${separator}YYYY`, // 5-1-2023
  `MMMM${separator}DD${separator}YYYY`, // May-01-2023
  `MMM${separator}DD${separator}YYYY`, // May-01-2023

  `MMMM DD YYYY`, // March 23 2023
  `MMM DD YYYY`, // Apr 01 2023
  `MMMM D YYYY`, // March 1 2023
  `MMM D YYYY`, // Apr 1 2023

  `YYYY${separator}MM${separator}DD`, // 12-06-2023
  `YYYY${separator}MM${separator}D`, // 05-1-2023
  `YYYY${separator}M${separator}D`, // 5-1-2023
  `YYYY${separator}MMMM${separator}DD`, // May-01-2023
  `YYYY${separator}MMM${separator}DD`, // May-01-2023
  `YY${separator}MM${separator}DD`, // 23-12-06

  `HH:mm:ss`, // 13:20:30
  `HH:mm`, // 13:20
  `h:mm:ss A`, // 01:20:30 PM
  `h:mm A`, // 01:20 PM
  `MM${separator}DD${separator}YYYY HH:mm:ss`, // 12-06-2023 13:20:30
  `MM${separator}DD${separator}YYYY HH:mm`, // 12-06-2023 13:20
  `MM${separator}D${separator}YYYY HH:mm:ss`, // 05-1-2023 13:20:30
  `MM${separator}D${separator}YYYY HH:mm`, // 05-1-2023 13:20
];

const generateDayFirstFormats = (separator: string) => [
  `DD${separator}MM`, // 06-12

  `D${separator}MM`, // 1-05
  `D${separator}M`, // 1-05

  `D${separator}MMMM`, // 1-May
  `D${separator}MMM`, // 1-May
  `DD${separator}MMM`, // 01-May

  `DD${separator}MM${separator}YY`, // 06-12-23
  `DD${separator}MM${separator}YYYY`, // 12-06-2023
  `D${separator}MM${separator}YYYY`, // 05-1-2023
  `D${separator}M${separator}YYYY`, // 5-1-2023
  `D${separator}M${separator}YY`, // 5-1-23
  `DD${separator}MMMM${separator}YYYY`, // May-01-2023
  `DD${separator}MMM${separator}YYYY`, // May-01-2023

  `YYYY${separator}DD${separator}MM`, // 2023-12-06
  `YYYY${separator}D${separator}MM`, // 2023-05-1
  `YYYY${separator}D${separator}M`, // 2023-5-1
  `YYYY${separator}DD${separator}MMMM`, // 2023-May-01
  `YYYY${separator}DD${separator}MMM`, // 2023-May-01
  `YY${separator}DD${separator}MM`, // 23-12-06

  `DD MMMM YYYY`, //  23 March 2023
  `DD MMM YYYY`, // 01 Apr 2023
  `D MMMM YYYY`, // 1 March 2023
  `D MMM YYYY`, // 1 Apr  2023

  `HH:mm:ss`, // 13:20:30
  `HH:mm`, // 13:20
  `h:mm:ss A`, // 01:20:30 PM
  `h:mm A`, // 01:20 PM
  `DD${separator}MM${separator}YYYY HH:mm:ss`, // 12-06-2023 13:20:30
  `DD${separator}MM${separator}YYYY HH:mm`, // 12-06-2023 13:20
  `D${separator}M${separator}YYYY HH:mm:ss`, // 05-1-2023 13:20:30
  `M${separator}M${separator}YYYY HH:mm`, // 05-1-2023 13:20
];

export const acceptedDateMonthFirstFormats = [
  ...generateMonthFirstFormats('-'),
  ...generateMonthFirstFormats('/'),
];

export const acceptedDateDayFirstFormats = [
  ...generateDayFirstFormats('-'),
  ...generateDayFirstFormats('/'),
];
